;(function ($, window, document, undefined) {

	var pluginName = "sgMenu",
		defaults = {
			toggle: true,
            addLinkCommands: false
		},
		that,
		nodeCache = {};

	function Plugin(element, options) {
		this.element = element;
		this.$element = $(element),
		this.settings = $.extend({}, defaults, options);
		this._defaults = defaults;
		this._name = pluginName;
		this.init();
	}

	Plugin.prototype = {
		init: function () {
			that = this;

			that.$element.find('li.parent a').on('click', this.toggleCategory);

			that.$element.bind('shopgate.categoryNavigation.onCategoryUpdate', this.buildSubcategory);
		},
		toggleCategory: function(e) {
			e.preventDefault();

			var $parent = $(this).closest('.parent');

			$parent.toggleClass('active').children('ul').collapse('toggle');

			if (!$parent.has('ul').length) {
				// Request subcategories if submenu is not there yet
				var parentNumber = $parent.data('number').toString();
				nodeCache[parentNumber] = $parent;
				that.$element.trigger('shopgate.categoryNavigation.getCategoryByCategoryNumber', [parentNumber]);
			}

			if (that.settings.toggle && $parent.hasClass('active')) {

				// Close other open categories
				$parent.siblings('.active').children('ul').on('hidden.bs.collapse', function () {
					$(this).off('hidden.bs.collapse');
					var offset = that.$element.find('.active').offset().top;
					if (offset < $('body').scrollTop()) {
						// If active submenu is not visible any more scroll to it
						$('body').animate({
							scrollTop: offset
						}, 'slow');
					}
				});
				$parent.siblings('.active').removeClass('active').children('ul.in').collapse('hide');

			}
		},
		buildSubcategory: function(e, parent) {
			var $parent = nodeCache[parent.category.number];
			if (!$parent.has('ul').length) {
				var $ul = $('<ul>', {
					class: 'collapse'
				}).appendTo($parent);

				// If parent is not active hide submenu
				if ($parent.hasClass('active')) {
					$ul.addClass('in');
				}

				// Build submenu with subcategories
				if (parent.category.hasOwnProperty('subcategories') && parent.category.subcategories != null ) {
					parent.category.subcategories.forEach(function(subcategory) {
                        var $sgCommands = null;
                        if(that.settings.addLinkCommands){
                            $sgCommands = JSON.stringify([
                                {SGAction: "openPage",
                                    params: {src: subcategory.category.url,targetTab:'main', title: subcategory.category.is_show_all ? parent.category.name : subcategory.category.name, previewSrc:"sgapi:page_preview", previewParams:null,navigationBarParams:{type:"default",popTab:null} } },
                                {SGAction: 'hideBackgroundMenu'},
                                {SGAction: 'showTab',
                                    params:{targetTab:'main'}}
                            ]);
                        }

						$ul.append($('<li>').append($('<a>', {
							href: subcategory.category.url,
							html: subcategory.category.name,
                            'data-sgcommands': $sgCommands
						})))
					});
				}
			}
		}
	};

	$.fn[ pluginName ] = function (options) {
		return this.each(function () {
			if (!$.data(this, "plugin_" + pluginName)) {
				$.data(this, "plugin_" + pluginName, new Plugin(this, options));
			}
		});
	};

})(jQuery, window, document);



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.sgMenu.js